import { SitemapDashboard } from '@dashboard/dashboard.types'
import { Flex, GridItem, Icon, Typography } from '@nilohealth/core-ui'
import { IconType } from 'react-icons'
import { MdOutlineAssignmentInd, MdOutlineFavoriteBorder, MdOutlineKeyboardArrowRight, MdOutlineShowChart }
  from 'react-icons/md'

import { DashboardsCategoryContainer, DashboardCategoryIcon, DashboardCategoryMarker, DashboardCategoryLink }
  from './dashboards.styles'

const categoryIcons: { [key: string]: IconType } = {
  engagement: MdOutlineAssignmentInd,
  performance: MdOutlineFavoriteBorder,
  'captacao-de-pacientes': MdOutlineShowChart,
}

type DashboardsCategoryProps = {
  category: SitemapDashboard
  isActive: boolean
  hoverIn: (id: number) => void
  openDashboard: () => void
}
const DashboardsCategory = ({ category, isActive, hoverIn, openDashboard }: DashboardsCategoryProps) => {
  const onMouseEnter = () => hoverIn(category.id)

  const open = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    openDashboard()
  }

  return (
    <DashboardsCategoryContainer
      columnTemplate="24px 16px 1fr 16px 16px 16px 2px"
      rowTemplate="1fr"
      onClick={open}
      onMouseEnter={onMouseEnter}
    >
      <GridItem key="icon" column="1" row="1">
        <DashboardCategoryIcon>
          <Icon icon={categoryIcons[category.slug] ?? MdOutlineAssignmentInd} size="small" color="primaryMedium" />
        </DashboardCategoryIcon>
      </GridItem>

      <GridItem key="text" column="3" row="1" css={{ overflow: 'hidden', width: '100%' }}>
        <Flex direction="column" gap="quarck" css={{ overflow: 'hidden' }}>
          {isActive ? (
            <DashboardCategoryLink>
              <Typography type="headingMedium" weight="bold" truncate>
                {category.name}
              </Typography>
            </DashboardCategoryLink>
          ) : (
            <Typography type="headingMedium" weight="bold" color="neutralLowDark" truncate>
              {category.name}
            </Typography>
          )}

          <Typography type="subtitleXXSmall" weight="regular" color="neutralLowMedium" truncate>
            {category.description ?? ''}
          </Typography>
        </Flex>
      </GridItem>

      <GridItem key="chevron" column="5" row="1" alignSelf="center">
        <Icon icon={MdOutlineKeyboardArrowRight} size="small" color="neutralLowDark" />
      </GridItem>

      <GridItem key="marker" column="7" row="1" alignSelf="center">
        {isActive && <DashboardCategoryMarker />}
      </GridItem>
    </DashboardsCategoryContainer>
  )
}

export default DashboardsCategory
